import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '../contexts/SubscriptionContext';
import PlanSelectionModal from './PlanSelectionModal';
import { Crown, Zap } from 'lucide-react';

const PremiumBanner = () => {
  const { isPremium, plans } = useSubscription();
  const [open, setOpen] = useState(false);

  if (isPremium) return null;

  const monthly = plans.find((p) => p.plan_type === 'monthly');
  const annual = plans.find((p) => p.plan_type === 'annual');

  return (
    <>
      <div
        className="relative overflow-hidden rounded-2xl border border-amber-500/40 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 shadow-xl mb-6"
        data-testid="premium-banner"
      >
        <div className="absolute inset-0 opacity-20 pointer-events-none"
             style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, rgba(251,191,36,0.35), transparent 40%)' }} />
        <div className="relative p-5 sm:p-8 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-5 sm:gap-6">
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-2 bg-amber-400/15 text-amber-300 text-xs font-semibold px-3 py-1 rounded-full mb-3">
              <Crown className="h-3.5 w-3.5" /> OPTION WIZARD PREMIUM
            </div>
            <h2 className="text-xl sm:text-3xl font-extrabold text-white leading-tight">
              Unlock the full power of Option Wizard
            </h2>
            <p className="text-slate-300 mt-2 text-sm sm:text-base">
              Scanners, AI analysis, portfolio tools, roll strategies & more — start with a{' '}
              <span className="text-amber-300 font-semibold">1-day free trial</span>.
            </p>
            <div className="flex flex-wrap items-end gap-x-4 gap-y-1 mt-4">
              <span className="text-amber-400 text-3xl font-extrabold">
                NOW ${monthly?.price ?? '19.99'}<span className="text-lg font-semibold text-amber-300/80">/mo</span>
              </span>
              <span className="text-slate-400">or ${annual?.price ?? '99.99'}/year</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
            <Button
              onClick={() => setOpen(true)}
              className="bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-slate-900 font-bold px-6 h-12 shadow-lg shadow-amber-500/25"
              data-testid="get-full-access-btn"
            >
              <Zap className="h-4 w-4 mr-2" /> Get Full Access
            </Button>
            <Button
              onClick={() => setOpen(true)}
              variant="outline"
              className="border-amber-400/40 text-amber-300 hover:bg-amber-400/10 h-12 px-6 font-semibold"
              data-testid="choose-plan-btn"
            >
              Choose Your Plan
            </Button>
          </div>
        </div>
      </div>
      <PlanSelectionModal open={open} onOpenChange={setOpen} />
    </>
  );
};

export default PremiumBanner;
